import { Button, Tooltip } from '@mui/material'
import { Bin } from 'chezy-inventory-backend/bin/database/types/Bin'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'

import { BinWithChildren } from '../../utils/createBinTree'

import { BinProgressBar } from './binProgress'

export const InventoryBinRow = (props: {
  bin: BinWithChildren
  progressFn: (bin: Bin) => { scanned: number; total: number; costScanned: number; totalCost: number }
  indent?: number
}) => {
  const progress = useMemo(() => props.progressFn(props.bin), [props])
  return (
    <>
      <div
        style={{
          padding: 10,
          paddingLeft: 10 + (props.indent ?? 0) * 20,
          fontWeight: props.bin.parent_id ? 'normal' : 'bold',
        }}
      >
        {props.bin.name} {props.bin.description && `- ${props.bin.description}`}
      </div>

      <div
        style={{
          padding: 10,
          paddingLeft: 10 + (props.indent ?? 0) * 20,
          fontWeight: props.bin.parent_id ? 'normal' : 'bold',
        }}
      >
        {!props.bin.parent_id && (
          <Tooltip arrow title="Scan or manually inventory this bin">
            <Button component={Link} to={`./${props.bin.id}`} variant="contained" style={{ margin: 10 }}>
              Scan Items
            </Button>
          </Tooltip>
        )}
      </div>

      <BinProgressBar progress={progress} />
      {props.bin.children?.map((child) => (
        <InventoryBinRow bin={child} progressFn={props.progressFn} indent={(props.indent ?? 0) + 1} />
      ))}
    </>
  )
}
